import { getDefault } from '@wufe/particles';
import { QuadTreeProgram } from './quadtree-program';
import { QuadTreeProximityDetectionSystem } from '../../quad-tree-proximity-detection-system';
export class QuadTreeFeatureBuilder {
}
QuadTreeFeatureBuilder.build = (partialParams) => ({
    build: (manager) => new QuadTreeFeature(manager, getDefault(partialParams, {
        color: [255, 229, 104, .21]
    }))
});
class QuadTreeFeature {
    constructor(_manager, _params) {
        this._manager = _manager;
        this._params = _params;
    }
    isAvailable() {
        return this._manager.getProximityDetectionSystem() instanceof QuadTreeProximityDetectionSystem;
    }
    buildProgram(gl, viewBox, libraryInterface, ...args) {
        this._program = new QuadTreeProgram(gl, viewBox, libraryInterface, this._params);
        return this;
    }
    getProgram() {
        return this._program;
    }
}
